import React from "react"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import TextField from "material-ui/TextField"
import AppStateStore from "../../../../stores/AppStateStore"
const moment = require("moment")

export default class IdentityDocSelectField extends React.Component {
    constructor(props) {
        super()
        this.state = {
            value: 0
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event, index, value) {}

    render() {
        const labelArray = [
            "U.S. Passport Card",
            "Permanent Resident Card",
            "Foreign Passport",
            "Employment Authorization Document",
            "Foreign Passport and Form I-94/A",
            "Passport from Federated Staes os Micronesia",
            "Photo ID card issued by federal, state or local government",
            "School Photo ID card",
            "Voter's registration card",
            "U.S. Militarty Dependent's Id Card"
        ]

        const valueArray = [1, 2, 3, 4, 5, 6]

        return (
            <div className="IdentityDocSelectField" style={{ marginTop: 20, marginBottom: 20, textAlign: "left" }}>
                <div style={{ color: "#cccccc", marginBottom: 10, fontSize: 12 }}>Identity Document List</div>
                <select
                    value={this.state.value}
                    onChange={this.handleChange}
                    style={{
                        width: "100%",
                        fontSize: "16px",
                        marginRight: 10,
                        border: "none",
                        borderBottom: "solid 1px #e1e1e1"
                    }}
                >
                    {labelArray.map(function(value, i) {
                        return (
                            <option value={valueArray[i]} key={i}>
                                {value}
                            </option>
                        )
                    })}
                </select>
            </div>
        )
    }
}
